import type { DeepWritable } from 'ts-essentials';
import type { SpreadsheetId } from '~/_shared/types/spreadsheetData/spreadsheetRow';
import { notNullsy } from '~/_shared/utils/typeGuards';
import type { SpreadsheetDataColumnsToFetch } from '~/spreadsheet/spreadsheet.repository';
import {
  type Chart, type ChartMetric, type ChartMetricLocationCount, isChartMetricLocationCount,
} from '~/store/mapSettings/data/charts/mapSettingsCharts.types';
import { type DataType } from '~/store/spreadsheetData/spreadsheetData.state';

const isLocationMetricWithColumnValue = (
  metric: ChartMetric,
): metric is ChartMetricLocationCount & {
  column: NonNullable<ChartMetricLocationCount['column']>;
  columnValue: NonNullable<ChartMetricLocationCount['columnValue']>;
} => isChartMetricLocationCount(metric) && notNullsy(metric.column) && notNullsy(metric.columnValue);

export const getLocationCountColumnNamesBySpreadsheet = (
  charts: ReadonlyArray<Chart>,
): Record<SpreadsheetId, SpreadsheetDataColumnsToFetch[DataType.GROUP]> => {
  return charts.reduce((acc, chart) => {
    chart.metrics
      .filter(isLocationMetricWithColumnValue)
      .forEach(metric => {
        const { spreadsheetId, columnId } = metric.column;

        acc[spreadsheetId] ??= {};
        acc[spreadsheetId][columnId] = {};
      });

    return acc;
  }, {} as Record<SpreadsheetId, DeepWritable<SpreadsheetDataColumnsToFetch[DataType.GROUP]>>);
};
